'use client';

import React, { useEffect } from 'react';
import classNames from 'classnames';

//* Styles
import MainStyle from './style';

const Page = ({ children, className }) => {
	useEffect(() => {
		window.history.scrollRestoration = 'manual';

		const handleBeforeUnload = () => {
			window.history.scrollRestoration = 'manual';
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			window.history.scrollRestoration = 'auto';
		};
	}, []);

	const classString = classNames({
		[className]: className,
	});

	return <MainStyle className={classString}>{children}</MainStyle>;
};

if (process.env.NODE_ENV !== 'production') {
	Page.displayName = 'Page';
}

export default Page;
